import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class TpDataImportExcludedItemSearchParams extends SearchParamsBase {
  initialize() {
    this.EntityType = '';
    this.Pattern = '';
    this.PatternType = '';
    this.Reason = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'EntityType', label: 'Entity Type', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Pattern', label: 'Pattern', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'PatternType',
      label: 'Pattern Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: TpDataImportExcludedItemSearchParams.getPatternTypeOptions(),
    },
    { fieldName: 'Reason', label: 'Reason', className: 'col-4', type: InputTypesEnum.Text },
  ];

  static indexOfFirstFieldInAdvanced = 4;
  static title = 'Search for Import Excluded Items';
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpDataImportExcludedItemSearchParams';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };
    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop] == null ? '' : correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }

  static getPatternTypeOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      { label: 'ThirdPartyId', value: 'ThirdPartyId', disabled: false },
      { label: 'FullEmail', value: 'FullEmail', disabled: false },
      { label: 'EmailDomain', value: 'EmailDomain', disabled: false },
    ];
  }
}
